export default class  PagedFilterAndSortedRequest{
    maxResultCount:number;
    skipCount:number;
    sorting:string;
    where:string;
}



// WEBPACK FOOTER //
// ./src/store/entities/page-request.ts